import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import ExclusionHistoryRegisterPage from "./ExclusionHistoryRegister.page";

function ExclusionHistoryPage() {
    return (
        <ToastProvider>
            <Dashboard>
                <ExclusionHistoryRegisterPage />
            </Dashboard>
            <Toast />
        </ToastProvider>
    );
}
export default ExclusionHistoryPage;
